// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq-module--faq--2fbva"};